'use strict';

export default {
  userList: {
    columns: {
      name: 'Name',
      email: 'Email',
      actions: 'Actions',
      status: 'Status   ',
    },
    status: {
      pending: 'Pending',
      active: 'Active',
    },
    buttons: {
      add: 'Add',
    },
    addModal: {
      addAdministrator: 'Add Administrator',
      email: 'Email',
    },
  },
};
